import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { usePrefetchIntent } from '../../hooks/usePrefetchIntent'
import { activeSectionWithChildren, isChildActive, visibleChildren } from '../../lib/nav-items'
import { cn } from '../../lib/utils'

export function SectionTabs() {
	const { pathname } = useLocation()
	const { hasPermission } = useAuth()
	const intent = usePrefetchIntent()
	const section = activeSectionWithChildren(pathname, hasPermission)

	if (!section) return null

	return (
		<nav aria-label={section.label} className="-mx-4 -mb-3 mt-1">
			<ul className="flex gap-1 overflow-x-auto px-2">
				{visibleChildren(section, hasPermission).map((child) => {
					const isActive = isChildActive(pathname, section, child)
					return (
						<li key={child.path} className="shrink-0">
							<Link
								to={child.path}
								replace
								{...intent(child.path)}
								aria-current={isActive ? 'page' : undefined}
								className={cn(
									'flex min-h-11 items-center border-b-2 px-3 text-sm whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-chrome-foreground/80',
									isActive
										? 'border-chrome-foreground font-medium text-chrome-foreground'
										: 'border-transparent text-chrome-foreground/80 hover:text-chrome-foreground',
								)}
							>
								{child.label}
							</Link>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}
